export default "__VITE_ASSET__e6899ec5__"